module.exports = __webpack_public_path__ + "img/6.aad4866c.jpg";